document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener('click', function (event) {
    const item = event.target.closest('.menu-item');
    if (item) {
      const submenu = item.querySelector('.submenu');
      const toggleIcon = item.querySelector('.toggle-icon');

      if (submenu && submenu.contains(event.target)) return;

      if (submenu.classList.contains('open')) {
        //submenu.style.maxHeight = '0';
        submenu.classList.remove('open', 'opened');
        toggleIcon?.classList.remove('rotate-down');
      } else {
        //submenu.style.maxHeight = submenu.scrollHeight + 'px';
        submenu.classList.add('open');
        toggleIcon?.classList.add('rotate-down');
      }
    }
  });

  document.addEventListener('click', function (event) {
    const thumbnail = event.target.closest('.youtube-thumbnail');
    if (thumbnail) {
      const video = thumbnail.closest('.youtube-video');
      const videoId = video.getAttribute('data-id');
      if (videoId) {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        
        thumbnail.innerHTML = '';
        thumbnail.classList.add('videoproduct');
        thumbnail.appendChild(iframe);
      }
    }
  });
  
  function checkScreenSize() {
    /* xs (extra small): <576px ; sm (small): ≥576px ; md (medium): ≥768px ; lg (large): ≥992px ; xl (extra large): ≥1200px */
    var width = window.innerWidth;
    var desktopOnlyContents = document.querySelectorAll('.popup-newsletter_image');  
    if (width < 768) {
      desktopOnlyContents.forEach(function(element) {
        element.parentNode.removeChild(element);
      });
    }
  }
  // Check screen size on initial load
  checkScreenSize();
  // Optional: Check screen size on window resize - Only for debug
  //window.addEventListener('resize', checkScreenSize);
});